import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { GetAllDepartments } from '../../../../../reduxToolkit/DocumentPanel/DocumentPanelApi';
import { GetAllFoodieDepartment } from '../../../../../reduxToolkit/Foodie/FoodieApi';
import { useTranslation } from 'react-i18next';
import {TABLES} from '../../../../../Apis/Tables';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const DeptScheduleApp = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { getAllFoodieDepartment, createsFoodieDepartment, updateFoodieDepartment } = useSelector((state) => state.employeeFoodieSlice);

    const [emptyFields, setEmptyFields] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [modified, setModified] = useState(0);
    const [itemSelect, setItemSelect] = useState(null);

    /**
     * Api to get all department
     */
    useEffect(() => {
        dispatch(GetAllDepartments())
    }, []);

    /**
     * Api to gel all foodie department
     */
    useEffect(() => {
        dispatch(GetAllFoodieDepartment())
    }, [modified, createsFoodieDepartment, updateFoodieDepartment]);

    /**
     * function to open the modal create
     */
    const handleCreate = () => {
        setShowCreateModal(true)
    }

    /**
     * function to open the modal update
     * @param item
     */
    const handleUpdate = (item) => {
        setItemSelect(item)
        setShowCreateModal(true)
    }

    /**
     * function to open the modal delete
     * @param item
     */
    const handleDelete = (item) => {
        setSelectedIds([item?.id])
        setShowDeleteModal(true)
    }

    /**
     * Api to delete items
     */
    const deleteSchedule = () => {
        dispatch(DeleteItemsApi({ tableName: TABLES.FOODIE_DEPARTMENT, body: selectedIds })).then(({ payload: { data: { success } } }) => {
            if (success) {
                setModified(prev => prev + 1);
            }
        });
    };

    return {
        emptyFields,
        setEmptyFields,
        showCreateModal,
        setShowCreateModal,
        showDeleteModal,
        setShowDeleteModal,
        selectedIds,
        setSelectedIds,
        modified,
        setModified,
        getAllFoodieDepartment,
        handleCreate,
        handleUpdate,
        handleDelete,
        deleteSchedule,
        DEV,
        permission,
        itemSelect,
        setItemSelect
    }
}

export default DeptScheduleApp;
